import styled from 'styled-components';
import { resolutions, screenDim } from '../../utils/styles';

interface DataColorIF {
  color?: string;
}

export const HeaderSOP = styled.div`

    padding: 9px;
    box-shadow: 0 8px 6px -6px #d1cece;
    text-align: center;
    background-color: #FFF;
    z-index: 100;

    .companyLogoImg {
      background-position: center;
      display: inline-block;
     }

    .company-logo {
      font-size: 26px;
      font-weight: bold;
      color: ${(props: DataColorIF) =>
        props.color?.toLocaleLowerCase() !== '#ffffff'
          ? props.color || '#666'
          : '#666'};
    }
    .logo {
      max-height: 40px;
    }
    .powered {
      color: #e5e5e5;
      font-size: 12px;
      margin: 8px 0 0;

    }
`;

export const HeaderImageSOP = styled.i<{url: string}>`
  background-image: url(${({ url }) => url });
  background-size: contain;
  background-repeat: no-repeat;


  height: 40px;
  width: 50vw;


`;
export const ButtonSlide = styled.button`
  mask-image: url(/assets/img/vu-chevron-up.svg);
  mask-repeat: no-repeat;
  width: 12px;
  height: 21px;
  padding: 0;
  border: none;
  margin-right: 16px;
  &:hover:not(.extreme) {
    cursor: pointer;
  }
  &.next {
    transform: rotate(180deg);
  }
  &.extreme {
    opacity: 0.75;
  }
`;
export const ValidationPageContainer = styled.div`
  margin-bottom: 10%;
  padding: 58px 15px 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  flex: 1;
  img {
    display: block;
    margin: 64px auto 16px;
    &.foot {
      text-align: center;
      margin: 32px auto auto;
      max-width: 130px;
    }
  }
  h1 {
    font-size: 48px;
  }
  h3 {
    text-align: center;
    color: ${(props: DataColorIF) => (props.color ? props.color : '#ef7a48')};
    font-weight: 500;
    font-size: 36px;
  }
  p {
    font-size: 14px;
    max-width: 278px;
    margin: 16px auto;
    strong {
      font-weight: 500;
    }
    &.sm {
      font-size: 12px;
      width: 316px;
    }
    &.id {
      width: 250px;
    }
    &.camera {
      width: 310px;
    }
    &.expiresIn {
      margin-top: 32px;
    }
    &.idface {
      white-space: break-spaces;
    }
  }
  .idFaceContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    padding: 64px 32px 16px;
    max-width: 393px;
    margin: auto;
    img {
      margin-top: 24px;
      margin-bottom: 0;
    }
  }
  .howTofaceContainer {
    max-width: 400px;
    margin: 0 auto;
    h4 {
      font-size: 18px;
      text-align: left;
    }
    .img {
      width: 140px;
    }
    .imgMedium {
      width: 120px;
    }
    section {
      display: grid;
      grid-template-columns: 148px 1fr;
      padding: 32px 0 24px;
      border-bottom: 2px dashed #CCC;
      &.leftContent {
        grid-template-columns: 166px 1fr;
        p {
          margin: 0;
        }
      }
      &:last-of-type {
        border-bottom: none;
      }
      .textContainer {
        text-align: left;
        padding: 0 0 0 16px;
        h5 {
          font-weight: 500;
          margin: 0 0 12px;
          font-size: 14px;
        }
      }
      img {
        margin: auto;
      }
      .id {
        width: 125px;
        margin-left: 0;
      }
      .face {
        width: 50px;
      }
      .camera {
        width: 76px;
        margin-left: 20px;
      }
    }
    p {
      text-align: left;
      margin: auto 16px auto auto;
    }
  }
  .warningContainer {
    margin: 5px 0 5px calc(50% - 120px);
    align-items: center;
    display: grid;
    grid-template-columns: 40px 1fr;
    img {
      margin: 0;
    }
    p {
      display: inline-block;
      text-align: left;
      font-size: 12px;
      font-weight: 500;
      margin: 0 0 0 20px;
      width: 205px;
    }
    label {
      margin: 0;
    }
  }
  .verificationFail {
    h3 {
      padding-top: 20px;
    }
    p {
      color: #A3A3A3;
      margin: 4px auto;
      &:first-of-type {
        margin-top: 20px;
      }
    }
    img {
      margin-top: 100px;
    }
  }
  .verificationSuccess {
    img {
      margin-top: 32px;
    }
    p {
      &:first-of-type {
        margin-top: 20px;
      }
    }
  }
  a {
    font-size: 12px;
    color: ${(props: DataColorIF) => (props.color ? props.color : '#ef7a48')};
  }
  button {
    border: 1px solid
      ${(props: DataColorIF) => (props.color ? props.color : '#ef7a48')};
    background-color: #fff;
    color: ${(props: DataColorIF) => (props.color ? props.color : '#ef7a48')};
    width: 100%;
    padding: 9px 0;
    font-size: 20px;
    font-weight: 400;
    border-radius: 25px;
    max-width: 170px;
    margin: 25px 0;
    &:hover {
      cursor: pointer;
    }
    &:disabled {
      /* background-color: #fff;
      color: rgba(16, 16, 16, 0.3);
      border-color: rgba(16, 16, 16, 0.3); */
      background: #C4C4C4;
      color: #FAFAFA;
      border: none;
      cursor: auto;
    }
  }
  ${ButtonSlide} {
    background-color: ${(props: DataColorIF) => (props.color ? props.color : '#ef7a48')};
  }
  .slick-dots li button:before {
    color: #e6e6e6;
    opacity: 1;
  }
  .slick-dots li.slick-active button:before {
    color: ${(props: DataColorIF) => (props.color ? props.color : '#ef7a48')};
  }
  .slick-dots li,
  .slick-dots li button {
    width: 12px;
  }

  .slick-dots li:last-of-type {
    display: none;
  }
  .terms {
    font-size: 12px;
  }
  .decoration {
    font-size: 12px;
    text-decoration: underline;
  }

  .buttonContainer {
    background: white;
    width: 100%;
    display: inline;
    grid-template-columns: 1fr 1fr;
    height: 40px;
    max-width: 400px;
    margin: auto;
    align-items: center;
    margin-top: -7px;
    .skip {
      justify-self: start;
      position: relative;
      display: inline-block;
      margin-right: 60%;
      button {
        background-color: white !important;
        border: none;
        color: ${(props: DataColorIF) => (props.color ? props.color : '#ef7a48')};
        padding: 8px 8px 8px 0;
        display: block;
        margin: 0;
        background: #fafafafa;
        z-index: 2;
        font-weight: 300;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .arrows {
      position: relative;
      justify-self: end;
      display: inline-block;

    }
    ${ButtonSlide} {
      border: none;
      width: 16px;
    }
  }
  .verificationLinkDeskt {
    margin-bottom: 50px;
  }
  @media ${resolutions.mobile} {
    .welcome {
      p {
        margin-bottom: 0;
      }
    }
    .buttonContainer {
      margin-top: -25px;

    }
    .howTofaceContainer {
      section {
        padding: 25px 0 10px;
      }
    }
  }

  @media (max-width: 400px) {
    .buttonContainer {
      margin-top: -45px;

    }
    .slick-dots {
      bottom: -5px;
    }
  }

  @media ${resolutions.desktop} {
    justify-content: flex-start;
    .verificationLinkDeskt {
      margin-top: 50px;
    }
    .buttonContainer {
      .button {
        &.desktop {
          display: inline-block;
        }
      }
    }
  }
`;

export const ValidationSlide = styled.div`
  text-align: center;
  outline: none !important;
`;

export const InvalidLinkContainer = styled.div`
  text-align: center;

  .button.close{
    justify-self: end;
  }

  h3 {
    font-size: 36px;
    margin: 25px 0 15px 0 ;
  }
  p {
    padding: 0 20px 0 20px;
    margin: 5px;
    color: #a3a3a3;
    font-size: 16px;
  }
  img {
    display: inline-block;
    height: 230px;
    width: 280px;
  }
  @media ${resolutions.desktop} {
    display: flex;
    justify-content: center;
    text-align: left;
    flex: 1;

    background-color: #F0F0F0;
    h3 {
      font-size: 64px;
      margin: 0 auto 45px auto;
    }
    p {
      padding:0;
      font-size: 18px;
    }
    img {
      margin: 0;
    }
    .error-expired {
      height: 100%;
    }
    .error-notavailable, .error-used {
      height: 70%;
    }
    .error-notexist {
      height: 50%;
    }
    .error-blockedAccess{
      height: 50%


    }
  }
`;

export const InvalidLinkContent = styled.div`
  .footerLinkError {
    margin-top: 50px;
  }
  a {
    color: ${(props: DataColorIF) => (props.color ? props.color : '#ef7a48')};
  }

  .button:hover  {
    background: ${(props: DataColorIF) => (props.color ? props.color : '#ef7a48')};
    color: #FFFFFF;
  }

  .button:focus {
    outline-color: ${(props: DataColorIF) => (props.color ? props.color : '#f87c56')};
    background: ${(props: DataColorIF) => (props.color ? props.color : '#ef7a48')};
    color: #FFFFFF;
  }



  @media ${resolutions.desktop} {
    width: 80%;
    margin: auto;
    padding: 24px 64px;
    box-sizing: border-box;
    box-shadow: 0px 4px 8px rgb(0 0 0 / 25%);
    background-color: #FFF;
    place-items: center;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    grid-template-areas:
          "header header"
          "footer footer";
    justify-items: center;
    .footerLinkError {
      margin-top: 0;
      justify-self: end;
      align-self: end;
      grid-area: footer;
      background-color: #FFF;
    }

  }


  }
`;


export const InvalidAccessContent = styled.div`
  padding: 24px 64px;
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: center;
  background-color: #FFF;
  @media ${resolutions.desktop} {
    height: calc(100% - 87px);}
  h3 {

    font-size: 36px;
    font-weight: 700;
    color : #f87c56;
    white-space: pre-line;
    margin: 0;
  }
  p {

    font-weight: 400;
    font-size: 24px;
    line-height : 1.6;
    text-align: center;
    color: #666666;
  }
  span{
    font-weight: 500;
  }
  h3 {


  }
  }
`;

export const ValidationMain = styled.div`
  background-color: white;

  @media ${resolutions.landscape} {
    max-height: 100%;

  }

  @media ${resolutions.mobile} {
    display: flex;
    flex-direction: column;
    flex: 1;

  }

  @media ${resolutions.desktop} {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex: 1;
    height: 100vh;
  }
}
`;

export const CheckboxStyled  = styled.div`

  align-items: center;
  display: grid;
  grid-template-columns: 40px 1fr;
  margin: 20px 0 20px calc(50% - 155px);

  input[type="checkbox"] {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  label {
     align-items: center;
     justify-content: center;
  }

  .checkbox {
    display: inline-block;
    height: 16px;
    width: 16px;
    background: #fff;
    border: 2px #ddd solid;
    margin-right: 4px;
    box-shadow: 0px 1px 1px rgba(102, 102, 102, 0.2), 0px 0px 0px 1px rgba(102, 102, 102, 0.5);
    border-radius: 4px;
  }

  .checkbox--active {
    border-color: #F87C56;
    background: #F87C56;
  }

  p {
    display: inline-block;
    text-align: left;
    margin-left: 5px;
    margin-bottom: 0;
    width: 89% ;
  }
`;

export const ProgressBar = styled.div`
  @keyframes progress {
    0% {
      width: 0;
      background: #909090;
    }

    50% {
      width: 30%;
      background: #909090;
    }

    100% {
      width: 100%;
      background: #909090;
    }
  }
  position: relative;
  display: inline-block;
  width: 300px;
  height: 5px;
  background: #dedede;
  border-radius: 4px;
  overflow: hidden;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    width: 0;
    height: 100%;
    border-radius: 4px;
    animation: progress 10s infinite;
  }
`;
